export default {
    draft: 'Draft',
    title: 'Innovation project',
    deprecated: 'This innovation project contains macro-trends that are no longer part of the current Trendone trend universe.'
}
